import styled from "@emotion/styled";

export const LeaguePageTitle = styled.h2`
	padding: 32px 0 0;
	cursor: pointer;
	font-size: 24px;

	@media (max-width: 880px) {
		padding: 16px 20px 0;
	}

	button {
		display: flex;
		flex-flow: row;
		align-items: center;
		gap: 5px;
		color: #fff;
		padding: 0;
		width: 100%;
		max-width: 100%;
		justify-content: flex-start;
		span {
			font-weight: 700;
			font-size: 28px;
			display: block;
			//overflow-wrap: break-word;
			text-overflow: ellipsis;
			overflow: hidden;
			max-width: 100%;
			flex: auto;
			text-align: left;
			@media (max-width: 880px) {
				font-size: 18px;
			}
		}
	}
	svg {
		color: #fff;
	}
`;

export const LeaguesLoadMoreButton = styled.button`
	background: none;
	box-shadow: none;
	text-decoration: underline;
	width: 100%;
	font-weight: 400;
	font-size: 14px;
	line-height: 150%;
	border: none;
	color: #fff;
`;
